export const CURRENCY_CODE = "GBP";
